export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8887.94f4a017.jpg";